import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms'
import { $ } from 'protractor';
import { RetornoChecklist } from 'src/app/models/retorno-checklist.model';
import { PreCheckoutService } from 'src/app/services/pre-checkout.service';
import { PreCheckoutQuery } from 'src/app/state/pre-checkout.query';

@Component({
  selector: 'app-pre-checkout-checklist',
  templateUrl: './pre-checkout-checklist.component.html',
  styleUrls: ['./pre-checkout-checklist.component.css']
})
export class PreCheckoutChecklistComponent implements OnInit {
  placa: string;

  checklistForm = this.formBuilder.group({
    placa: '',
    cpf: ''
  });

  consultaChecklistRealizada: boolean = false;
  consultaChecklistSucesso: boolean = false;
  dataUltimoChecklist: Date;
  diasPassadosUltimoChecklist: string;
  statusChecklist: string;
  mensagem: string;

  constructor(private formBuilder: FormBuilder,
    private preCheckoutQuery: PreCheckoutQuery,
    private preCheckoutService: PreCheckoutService) { }

  ngOnInit(): void { }

  onSubmit(): void {
    if (this.validForm()){
      let placa: string = (this.checklistForm.value.placa.toString()).toUpperCase();
      this.preCheckoutService.getChecklist(placa, this.checklistForm.value.cpf)
        .subscribe(
          (result) => {
            this.placa = placa;
            this.consultaChecklistRealizada = true;
            this.consultaChecklistSucesso = result.sucesso;
            this.dataUltimoChecklist = result.data_ultimo_checklist;
            this.diasPassadosUltimoChecklist = result.dias_passados_ultimo_checklist.toString();
            this.statusChecklist = result.status_checklist;
            this.mensagem = result.mensagem;
          }
        );
    }
  }

  validForm() {
    return this.checklistForm.valid;
  }

  invalidPlaca() {
    return this.checklistForm.value.placa.length != 7;
  }

  invalidCpf() {
    return this.checklistForm.controls.cpf.errors?.cpfNotValid && 
      this.checklistForm.value.cpf.length != 11;
  }

  limpar() {
    this.consultaChecklistRealizada = false;
    this.consultaChecklistSucesso = false;
    this.dataUltimoChecklist = new Date();
    this.diasPassadosUltimoChecklist = '';
    this.statusChecklist = '';
    this.mensagem = '';
  }
}
